import { render, staticRenderFns } from "./bjtjfx.vue?vue&type=template&id=35008c62&scoped=true&"
import script from "./bjtjfx.vue?vue&type=script&lang=js&"
export * from "./bjtjfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35008c62",
  null
  
)

export default component.exports